export class VenueCreateRequestModel {
    
    companyId!: number;
    name?: string
    description?: string
    address?: string;
    city?: string;
}
